import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {catchError, switchMap} from 'rxjs/operators';
import {UserListLoadActions, UserLoadActions, UserPageActions} from '../actions/userActions';
import {UserService} from '../../../services/user/user.service';
import {map, of} from 'rxjs';
import { HttpStatusCode } from '@angular/common/http';


@Injectable()
export class UserEffects {
  loadUserPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPageActions.load),
      switchMap(({userId}) => {
          return this.userService.getUserPage(userId).pipe(
            map((userPage) => {
              return UserPageActions.loaded({userPage});
            }),
            catchError((error) => of(UserPageActions.errorLoading(error)))
          );
        }
      )
    )
  );

  loadUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserLoadActions.load),
      switchMap(({userId}) =>
        this.userService.getUserPage(userId).pipe(
          map((user) => UserLoadActions.loaded({user, loading: false})),
          catchError((error) => {
              if (error === HttpStatusCode.NotFound) {
                return of(UserLoadActions.notFound());
              } else {
                return of(UserLoadActions.errorLoading(error));
              }
            }
          ))));
  });

  loadUserList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserListLoadActions.loadUser),
      switchMap(() =>
        this.userService.getAllBrokerAndUnderwriter().pipe(
          map((users) => UserListLoadActions.loaded({users})),
          catchError((error) => of(UserListLoadActions.errorLoading(error))))
      )
    );
  });
  loadUserListByLOB$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserListLoadActions.loadUsersByLOB),
      switchMap(value =>
        this.userService.getAllBrokerAndUnderwriter(value.lobNumber).pipe(
          map((users) => UserListLoadActions.loaded({users})),
          catchError((error) => of(UserListLoadActions.errorLoading(error))))
      )
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly userService: UserService
  ) {
  }
}
